import { FormControlClassKey } from '@material-ui/core/FormControl';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const THDFormControlStyles: Partial<
  Record<FormControlClassKey, CSSProperties>
> = {};
